<template>
  <transition name="fade" mode="out-in">
    <v-row justify-sm="center" :justify-lg="justifyLg" v-if="show">
      <v-alert
        icon="mdi-emoticon-excited"
        :class="{ 'my-6': true, auth: auth, 'auth-like': authLike }"
        type="info"
        outlined
        text
        color="orange"
        :title="$t('appUpdated.title')"
        :width="width"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ $t("appUpdated.text") }}
            <span v-if="user.isProvider || user.isExpert">
              {{ $t("appUpdated.advancedText") }}
            </span>
          </v-col>
          <v-col class="shrink">
            <v-btn @click="show = false">{{ $t("ok") }}</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-row>
  </transition>
</template>

<script>
import checkMobileMixin from "Shared/mixins/checkMobileMixin";
import checkTabletMixin from "Shared/mixins/checkTabletMixin";
import userMixin from "Shared/mixins/userMixin";

export default {
  name: "AppUpdatedAlert",
  mixins: [checkMobileMixin, checkTabletMixin, userMixin],
  props: {
    auth: {
      type: Boolean,
      default: false,
    },
    authLike: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    justifyLg() {
      if (this.auth || this.authLike) return "center";
      return "start";
    },
    width() {
      if (this.mobile || this.tablet) {
        if ((this.auth || this.authLike) && this.mobile) return "100%";
        if ((this.auth || this.authLike) && this.tablet) return "75%";
        return "90%";
      }
      return "75%";
    },
  },
  created() {
    if (!this.user.id) return;
    Echo.private(`app.updated`).listen("AppUpdated", () => {
      this.show = true;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "~PublicStyles/_variables.scss";
.auth {
  position: absolute;
  top: 0;

  @media ($mobile) {
    margin-left: 24px;
    margin-right: 12px;
  }
}

.auth-like {
  @media ($mobile) {
    margin: 0 24px;
  }
}
</style>
